import React, { Component } from 'react';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from '../../Loader';

class Create extends Component {
	render() {
		let { AppConfig, actions } = this.props;

		let {
			isLoadingAction,

			string_formInput,
		} = AppConfig;

		return (
			<form>
				<Loader loading={isLoadingAction} />
				<Row>
					<Col md={12}>
						<FormControl
							value={string_formInput}
							onChange={(e) =>
								actions.setValue({
									string_formInput: e.target.value,
								})
							}
						/>
					</Col>
				</Row>
			</form>
		);
	}
}

function mapStateToProps(state) {
	let { AppConfig } = state;

	return {
		AppConfig,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/AppConfig/FormContainer/StringForm.js